<template>
    <oc-text-input
        v-model="model"
        v-bind="$_inputAttrs"
        :placeholder="placeholder"
        v-on="$listeners"
        :disabled="disabled"
    />
</template>

<script>
import DateTimeRangeInput from '@/components/form/advanced/datetime/DateTimeRangeInput'

export default {
    name: 'oc-datetime-input',
    extends: DateTimeRangeInput,
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        /**
         * Input value - used for v-model
         */
        value: {
            type: String,
            default: ''
        },
        ranges: {
            type: [Object, Boolean],
            default: false
        }
    },
    methods: {
        emitState() {
            Vue.nextTick(() => {
                this.$emit('input', this.picker.startDate.format(this.format))
            })
        }
    },
    watch: {
        'value': {
            immediate: true,
            handler(newValue) {
                if( this.picker ) {
                    let value = newValue

                    if( ! value ) {
                        value = this.moment().format(this.$_options.locale.format)
                    }

                    this.picker.setStartDate(value)
                    this.picker.setEndDate(value)
                }
            }
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                Vue.nextTick(() => {
                    this.$emit('input', value)
                })
            }
        },
        $_options() {
            let options = DateTimeRangeInput.computed.$_options.call(this)

            options.singleDatePicker = true

            if( ! this.value ) {
                options.startDate = options.endDate = this.moment().format(options.locale.format)
            } else {
                options.startDate = this.value
            }

            return options
        }
    }
}
</script>
